export const footerObj = {
  policies: [
    {
      link: '/terms-of-use.php',
      absoluteLink: 'https://www.ketto.org/terms-of-use.php',
      text: 'Terms of Use'
    },
    {
      link: '/privacy-policy.php',
      absoluteLink: 'https://www.ketto.org/privacy-policy.php',
      text: 'Privacy Policy'
    },
    {
      link: 'https://customerhappiness.ketto.org/portal/en/kb/articles/aml-policy-6-8-2021',
      absoluteLink: 'https://customerhappiness.ketto.org/portal/en/kb/articles/aml-policy-6-8-2021',
      text: 'AML Policy'
    },
    {
      link: '/support/use-of-cookies.php',
      absoluteLink: 'https://www.ketto.org/support/use-of-cookies.php',
      text: 'Use of cookies'
    },
  ],
  fundraise: [
    {
      link: 'https://amazonwings.ketto.org/',
      absoluteLink: 'https://amazonwings.ketto.org/',
      text: 'Crowdfunding for Amazon Wing',
    },
    {
      link: 'https://www.ketto.org/campaign/crowdfunding-for-education.php',
      absoluteLink: 'https://www.ketto.org/campaign/crowdfunding-for-education.php',
      text: 'Crowdfunding for Education',
    },
    {
      link: 'https://covid19.ketto.org/',
      absoluteLink: 'https://covid19.ketto.org/',
      text: 'Coronavirus Relief Fund',
    }
  ],
  how_it_works: [
    {
      link: '/how_it_works/fundraising-ideas-for-ngos.php',
      absoluteLink: 'https://www.ketto.org/how_it_works/fundraising-ideas-for-ngos.php',
      text: 'Fundraising for NGOs'
    },
    {
      link: 'https://www.ketto.org/new/sip?utm_source=internal_Ketto&utm_term=footer',
      absoluteLink: 'https://www.ketto.org/new/sip?utm_source=internal_Ketto&utm_term=footer',
      text: 'Sponsor A Child'
    },
    {
      link: '/support/fundraising-tips-ideas.php',
      absoluteLink: 'https://www.ketto.org/support/fundraising-tips-ideas.php',
      text: 'Fundraising Tips'
    },
    {
      link: '/crowdfunding',
      absoluteLink: 'https://www.ketto.org/crowdfunding',
      text: 'What is Crowdfunding?'
    },
    {
      link: '/how_it_works/fundraising-ideas-for-corporates.php',
      absoluteLink: 'https://www.ketto.org/how_it_works/fundraising-ideas-for-corporates.php',
      text: 'Corporates'
    },
    {
      link: 'https://customerhappiness.ketto.org/portal/en/kb/funds-withdrawal',
      absoluteLink: 'https://customerhappiness.ketto.org/portal/en/kb/funds-withdrawal',
      text: 'Withdraw Funds',
    },
    {
      link: '/crowdfunding',
      absoluteLink: 'https://www.ketto.org/crowdfunding/fundraisers',
      text: 'Browse Fundraiser'
    },
    {
      link: '/hospitals',
      absoluteLink: 'https://www.ketto.org/hospitals',
      text: 'Find Hospitals'
    }
  ],
  support: [
    {
      link: '/medical-finance-loans',
      absoluteLink: 'https://www.ketto.org/medical-finance-loans',
      text: 'Medical Finance'
    },
    {
      link: 'https://customerhappiness.ketto.org/portal/en/kb',
      absoluteLink: 'https://customerhappiness.ketto.org/portal/en/kb',
      text: 'FAQs & Help Center'
    },
    {
      link: 'https://www.ketto.org/blog/are-campaigns-in-ketto-genuine',
      absoluteLink: 'https://www.ketto.org/blog/are-campaigns-in-ketto-genuine',
      text: 'Are Ketto Campaigns Genuine?'
    }, {
      link: '/support/campaign-video.php',
      absoluteLink: 'https://www.ketto.org/support/campaign-video.php',
      text: 'Fundraiser Video'
    },
    {
      link: 'https://customerhappiness.ketto.org/portal/en/kb/trust-safety-queries',
      absoluteLink: 'https://customerhappiness.ketto.org/portal/en/kb/trust-safety-queries',
      text: 'Trust & Safety'
    },
    {
      link: '/support/plans-and-pricing.php',
      absoluteLink: 'https://www.ketto.org/support/plans-and-pricing.php',
      text: 'Plans & Pricing*'
    },
    // {
    //     link: 'https://www.ketto.org/support/payouts.php',
    //     absoluteLink: 'https://www.ketto.org/support/payouts.php',
    //     text: 'Payouts'
    // },
    // {
    //     link: 'https://support.ketto.org/hc/en-us/articles/360035965313-Trust-Safety',
    //     absoluteLink: 'https://support.ketto.org/hc/en-us/articles/360035965313-Trust-Safety',
    //     text: 'Trust & Safety'
    // },
    {
      link: '/support/contact-us.php',
      absoluteLink: 'https://www.ketto.org/support/contact-us.php',
      text: 'Contact Us'
    }
  ],
  aboutUs: [
    {
      // link: '/new/about/about-us',
      // absoluteLink: '/new/about/about-us',
      link: '/new/about/about-us',
      absoluteLink: 'https://www.ketto.org/new/about/about-us',
      text: 'Team Ketto'
    },
    {
      link: '/new/press-club',
      absoluteLink: 'https://www.ketto.org/new/press-club',
      text: 'In The News'
    },
    {
      link: '/web-stories',
      absoluteLink: 'https://www.ketto.org/web-stories',
      text: 'Web Stories'
    },
    // {
    //     link: '/about/our-partners.php',
    //     absoluteLink: 'https://www.ketto.org/about/our-partners.php',
    //     text: 'Our Partners'
    // },
    {
      // link: '/about/careers.php',
      // absoluteLink: 'https://www.ketto.org/new/about/about-us',
      // absoluteLink: 'https://www.ketto.org/about/careers.php',
      link: 'https://ketto.kekahire.com/',
      absoluteLink: 'https://ketto.kekahire.com/',
      text: 'Careers'
    },
    {
      link: 'https://www.ketto.org/blog',
      absoluteLink: 'https://www.ketto.org/blog',
      text: 'Ketto Blog'
    },
    {
      link: '/new/success-stories',
      absoluteLink: 'https://www.ketto.org/new/success-stories',
      text: 'Success Stories'
    },
    {
      link: '/blog/is-ketto-genuine',
      absoluteLink: 'https://www.ketto.org/blog/is-ketto-genuine',
      text: 'Is Ketto Genuine?'
    }
  ],
  mobileMenu: [
    {
      link: 'https://customerhappiness.ketto.org/portal/en/kb/articles/terms-of-use-7-8-2021-1',
      absoluteLink: 'https://customerhappiness.ketto.org/portal/en/kb/articles/terms-of-use-7-8-2021-1',
      text: 'Terms of Use'
    },
    {
      link: 'https://customerhappiness.ketto.org/portal/en/kb/articles/privacy-policy-7-8-2021',
      absoluteLink: 'https://customerhappiness.ketto.org/portal/en/kb/articles/privacy-policy-7-8-2021',
      text: 'Privacy Policy'
    },
    {
      link: 'https://customerhappiness.ketto.org/portal/en/kb/articles/aml-policy-6-8-2021',
      absoluteLink: 'https://customerhappiness.ketto.org/portal/en/kb/articles/aml-policy-6-8-2021',
      text: 'AML Policy'
    },
    {
      link: '/support/use-of-cookies.php',
      absoluteLink: 'https://www.ketto.org/support/use-of-cookies.php',
      text: 'Use of cookies'
    },
    {
      link: 'https://customerhappiness.ketto.org/portal/en/kb',
      absoluteLink: 'https://customerhappiness.ketto.org/portal/en/kb',
      text: 'Help Center'
    },
    {
      link: '/support/plans-and-pricing.php',
      absoluteLink: 'https://www.ketto.org/support/plans-and-pricing.php',
      text: 'Plans & Pricing*'
    },
    {
      link: '/new/about/about-us',
      absoluteLink: '/new/about/about-us',
      text: 'Team Ketto'
    },
    {
      link: '/new/press-club',
      absoluteLink: 'https://www.ketto.org/new/press-club',
      text: 'Press Club'
    },
    // {
    //     link: 'https://support.ketto.org/hc/en-us/articles/360035965313-Trust-Safety',
    //     absoluteLink: 'https://support.ketto.org/hc/en-us/articles/360035965313-Trust-Safety',
    //     text: 'Trust & Safety'
    // },
    {
      link: '/support/contact-us.php',
      absoluteLink: 'https://www.ketto.org/support/contact-us.php',
      text: 'Contact Us'
    },
    {
      link: 'https://ketto.kekahire.com/',
      absoluteLink: 'https://ketto.kekahire.com/',
      text: 'Careers'
    },
    {
      link: 'https://www.ketto.org/blog',
      absoluteLink: 'https://www.ketto.org/blog',
      text: 'Ketto Blog'
    },
    {
      link: '/crowdfunding/cause/medical-fundraising',
      absoluteLink: 'https://www.ketto.org/cause/medical-fundraising',
      text: 'Medical crowdfunding',
    },
    {
      link: '/cause/transplant-crowdfunding',
      absoluteLink: 'https://ketto.org/cause/transplant-crowdfunding',
      text: 'Transplant Crowdfunding',
    },
    {
      // link: '/how_it_works/fundraising-ideas-for-ngos.php',
      // absoluteLink: 'https://www.ketto.org/how_it_works/fundraising-ideas-for-ngos.php',
      // text: 'NGOs'
      link: '/web-stories',
      absoluteLink: 'https://www.ketto.org/web-stories',
      text: 'Web Stories'
    },
    {
      link: '/cause/sports-crowdfunding',
      absoluteLink: 'https://ketto.org/cause/sports-crowdfunding',
      text: 'Sports Crowdfunding',
    },
  ],
  causes: [
    {
      link: '/crowdfunding/cause/medical-fundraising',
      absoluteLink: 'https://www.ketto.org/cause/medical-fundraising',
      text: 'Medical crowdfunding',
    },
    {
      link: '/cause/cancer-crowdfunding',
      absoluteLink: 'https://www.ketto.org/cause/cancer-crowdfunding',
      text: 'Cancer Crowdfunding',
    },
    {
      link: '/cause/transplant-crowdfunding',
      absoluteLink: 'https://www.ketto.org/cause/transplant-crowdfunding',
      text: 'Transplant Crowdfunding'
    },
    {
      link: '/cause/fundraising-for-education',
      absoluteLink: 'https://www.ketto.org/cause/fundraising-for-education',
      text: 'Education Crowdfunding',
    },
    {
      link: '/cause/sports-crowdfunding',
      absoluteLink: 'https://www.ketto.org/cause/sports-crowdfunding',
      text: 'Sports Crowdfunding',
    },
    {
      link: '/cause/help-children',
      absoluteLink: 'https://www.ketto.org/cause/help-children',
      text: 'Child Welfare'
    },
    {
      link: '/cause/animal-fundraising',
      absoluteLink: 'https://www.ketto.org/cause/animal-fundraising',
      text: 'Animal Fundraisers',
    }
  ]
};
